// extracted by mini-css-extract-plugin
export default {"bannerHeader":"styles---bannerHeader---So0cT","innerBannerHeader":"styles---innerBannerHeader---rbU0Q","bottomMobileNavigationOffset":"styles---bottomMobileNavigationOffset---SHmgu"};